
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookie-consent",
      function () {
        return require("private-next-pages/cookie-consent.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cookie-consent"])
      });
    }
  